<template>
  <section>
    <p class="gp-section-title">
      <span>{{ position }}</span
      >Weiteres Zubehör
    </p>

    <div class="g-pb-10" v-if="description">
      <p class="gea-two-column-description">
        {{ description }}
      </p>
    </div>

    <div class="gp-2-column">
      <div class="gp-left-column">
        <section-content
          class="g-mb-6"
          v-for="block of leftColumn"
          :key="block.position"
          :title="block.title"
          :body="block.text"
          :link="block.link"
        ></section-content>
      </div>

      <div class="gp-right-column">
        <section-content
          class="g-mb-6"
          v-for="block of rightColumn"
          :key="block.position"
          :title="block.title"
          :body="block.text"
          :link="block.link"
        ></section-content>
      </div>
    </div>
  </section>
</template>

<script>
import BigOptionList from "../components/BigOptionList.vue";
import RoofImage from "../components/RoofImage.vue";
import SectionContent from "../components/SectionContent.vue";

export default {
  components: { SectionContent, BigOptionList, RoofImage },
  name: "Zubehoer",

  created() {
    this.$store.dispatch("zubehoer/fetchOptions");
  },

  computed: {
    leftColumn() {
      if (!this.options) return [];
      let count = Math.round(this.options.length / 2);
      return this.options.slice(0, count);
    },

    rightColumn() {
      if (!this.options) return [];
      let count = Math.round(this.options.length / 2);
      return this.options.slice(count);
    },

    options() {
      return this.$store.state.zubehoer.options;
    },
  },

  props: ["position", "description"],
};
</script>

<style></style>
